<script setup lang="ts">
  import { Text } from "@ui-kit";
  import { Image } from "../Image";

  const { image, name, article, color } = defineProps<{
    image: string;
    name: string;
    article: string;
    color?: string;
    additionalInfo?: string;
  }>();

  const emit = defineEmits<{
    (e: "click"): void;
  }>();
</script>

<template>
  <div class="item" @click="emit('click')">
    <div class="content">
      <div class="item__image">
        <Image :url="image" />
        <slot name="after-image" />
      </div>
      <div class="info" :class="{ 'with-additional-info': additionalInfo }">
        <Text font="body-medium-16" data-testid="product-mini-card-name" :wrap="false">{{ name }}</Text>
        <Text font="body-regular-14" color="secondary" :wrap="false" data-testid="product-mini-card-article">
          {{ `${article}${color ? ", " + color : ""}` }}
        </Text>
        <slot name="additional-info" />
      </div>
    </div>
  </div>
</template>

<style scoped>
  .item {
    display: flex;
    width: 100%;
    overflow: hidden;
    flex-shrink: 0;

    .content {
      display: flex;
      flex: 1;
      gap: 12px;
      align-items: center;
      overflow: hidden;
    }

    .item__image {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      width: 50px;
      height: 56px;
      overflow: hidden;
      border-radius: 8px;
    }

    .info {
      display: flex;
      flex-direction: column;
      gap: 4px;
      overflow: hidden;

      &.with-additional-info {
        gap: 0;

        & :deep(.text) {
          white-space: wrap;
        }
      }

      & :deep(.text) {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>
